export default __webpack_public_path__ + "static/media/nft-awe2.a287a399.jpg";